import { ACQUISITION_BONUS_INFO_BAR_BANNER_VIEW } from '../actions/types';

export const acquisitionBonusInfoBarBannerGaActionEvents = {
  [ACQUISITION_BONUS_INFO_BAR_BANNER_VIEW]: () => (
    {
      category: 'Acq Infobar CH',
      action: 'View',
      value: 1,
    }
  ),
};

export const acquisitionBonusInfoBarBannerClickEvents = [
  {
    selector: '.mn_acquisitionBonusInfoBarBanner a',
    click: {
      category: 'Acq Infobar CH',
      action: 'Click',
    },
    value: 1,
  },
];
